import { render, staticRenderFns } from "./QCrud.vue?vue&type=template&id=7df77dd7&"
import script from "./QCrud.vue?vue&type=script&lang=js&"
export * from "./QCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports